import React, { useEffect, useRef } from "react";
import { Element } from "react-scroll";
import { upperFirst } from "lodash";
import { useProfileSection } from "./ProfileSectionContext";

export interface ProfileSectionWrapperProps {
  children: React.ReactNode;
  label: string;
  id: string;
  className?: string;
}

export const ProfileSectionWrapper: React.FC<ProfileSectionWrapperProps> = ({
  children,
  label,
  id,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { registerSection, unregisterSection } = useProfileSection();

  const labelText = upperFirst(label);

  useEffect(() => {
    registerSection({ id, label: labelText });

    return () => {
      unregisterSection(id);
    };
  }, [id, label, registerSection, unregisterSection]);

  return (
    <div ref={ref} id={id} className={className}>
      <Element name={labelText} id={id}>
        {children as any}
      </Element>
    </div>
  );
};

export default ProfileSectionWrapper;
